import { LanguageService } from '../services/language.service';

/**
 * Google Places language from app locale (en / fr).
 * Avoids browser locale leaking Vietnamese names like "Pháp".
 */
export function resolvePlacesLanguage(
  languageService: LanguageService,
): string {
  const lang = languageService.getCurrentLang()?.toLowerCase();
  if (lang?.startsWith('fr')) {
    return 'fr';
  }
  if (lang?.startsWith('en')) {
    return 'en';
  }
  return 'en';
}
